import React, { createContext, useContext, useState, useCallback } from 'react';

import Snackbar from './snackbar';

import type { SnackbarContextType } from './types';

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined);

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('info');

  const showSnackbar = useCallback((msg: string, sev: typeof severity = 'info') => {
    setMessage(msg);
    setSeverity(sev);
    setOpen(true);
  }, []);

  const handleClose = () => setOpen(false);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar open={open} onClose={handleClose} message={message} severity={severity} />
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = (): SnackbarContextType => {
  const context = useContext(SnackbarContext);
  if (!context) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Snackbar] useSnackbar called outside SnackbarProvider — returning no-op. Stack:', new Error().stack);
    }
    return { showSnackbar: () => {} };
  }
  return context;
};
